import { dispatch } from './src/Action'
import {
  closeFiltersTray,
  createAsset,
  createAssetReference,
  createBudget,
  destroyMoment,
  destroyPostPlacement,
  destroyReaction,
  fetchWorkflowAction,
  getAccount,
  getBudget,
  getMoment,
  getMomentsRequest,
  getPlacements,
  getPresentationThemes,
  getRichTextCurrent,
  getStoryV2,
  getToken,
  getUsers,
  getWorkflow,
  loadJsonApiEntities,
  markApprovalComplete,
  openFiltersTray,
  postReaction,
  registerDropData,
  registerShroudVisible,
  servicesLoaded,
  setCurrentStory,
  setCurrentWorkspace,
  setWeekViewStartDay,
  updateAssetReference,
  updateBudget,
  updateContentV2,
  updateMoment,
} from './src/actions'
import { selectUsers, selectUsersToArray } from './src/selectors/selectors'

export { ReduxUpdateQueue } from './src/jsonApiDeserializer/reduxUpdateQueue'
export {
  channelNameMaps,
  gemChannelNameMaps,
} from './src/jsonApiParser/decorators'
export const Action = { dispatch }

export const actions = {
  closeFiltersTray,
  createAsset,
  createAssetReference,
  createBudget,
  fetchWorkflowAction,
  getAccount,
  getBudget,
  getMoment,
  getMomentsRequest,
  getPresentationThemes,
  getStoryV2,
  getToken,
  getUsers,
  getWorkflow,
  loadJsonApiEntities,
  markApprovalComplete,
  openFiltersTray,
  registerDropData,
  registerShroudVisible,
  servicesLoaded,
  setCurrentStory,
  setCurrentWorkspace,
  setWeekViewStartDay,
  updateAssetReference,
  updateBudget,
  updateMoment,
}

export const selectors = {
  selectUsers,
  selectUsersToArray,
}

export {
  destroyMoment,
  destroyPostPlacement,
  destroyReaction,
  dispatch,
  getMoment,
  getPlacements,
  getRichTextCurrent,
  postReaction,
  updateContentV2,
}
